import * as Joi from "joi";
import * as React from "react";
import * as routes from "../../constants/routes";
import { firebaselogin } from "../../firebase/firebaselogin";
import logo from "../../images/logo-blue.png";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";

import "../../signin.css";
import { Header } from "semantic-ui-react";

interface IInterfaceProps {
  history: any;
}

interface IInterfaceState {
  error: any;
  isSignedIn: boolean;
}

export class SignInForm extends React.Component<
  IInterfaceProps,
  IInterfaceState
> {
  private uiConfig = {
    signInFlow: "redirect",
    signInOptions: [
      {
        provider: firebaselogin.auth.GoogleAuthProvider.PROVIDER_ID,
        fullLabel: "Continue with Google",
      },
      {
        provider: firebaselogin.auth.EmailAuthProvider.PROVIDER_ID,
        fullLabel: "Sign In or Sign Up with email",
        buttonColor: "#5e2ced",
      },
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => {
        this.props.history.push(
          localStorage.getItem("redirectUrl")
            ? localStorage.getItem("redirectUrl")
            : routes.ORGANIZATIONS
        );
        return true;
      },
    },
    tosUrl: "http://www.metricsquare.com/#tos",
    privacyPolicyUrl: "http://www.metricsquare.com/#privacy",
  };

  private unregisterAuthObserver = null;

  private static INITIAL_STATE = {
    data: {
      email: "",
      password: "",
    },
    error: null,
    errors: {},
    isSignedIn: true,
  };

  private static schema: Joi.SchemaLike = {
    email: Joi.string().required().label("Name"),
    password: Joi.string().required().label("Password"),
  };

  constructor(props: IInterfaceProps) {
    super(props, SignInForm.schema);
    this.state = { ...SignInForm.INITIAL_STATE };
  }
  public componentDidMount = () => {
    this.unregisterAuthObserver = firebaselogin
      .auth()
      .onAuthStateChanged((authUser) => {
        if (authUser) {
          this.setState({ isSignedIn: true });
          this.props.history.push(routes.NEW_ORGANIZATION);
        } else {
          this.setState({ isSignedIn: false });
        }
      });
  };

  public componentWillUnmount = () => {
    if (this.unregisterAuthObserver) {
      this.unregisterAuthObserver();
    }
  };

  public render() {
    return (
      !this.state.isSignedIn && (
        <React.Fragment>
          <Header as="h1" textAlign="center">
            <img alt="BotSights Logo" src={logo} style={{ width: "250px" }} />
          </Header>
          <Header as="h1" textAlign="center" style={{ marginBottom: "52px" }}>
            Sign in to MetricSquare
            <Header.Subheader>
              Continue with the Google account or email address you use to sign
              in.
            </Header.Subheader>
          </Header>

          <StyledFirebaseAuth
            className="firebase-ui"
            uiConfig={this.uiConfig}
            firebaseAuth={firebaselogin.auth()}
          />
        </React.Fragment>
      )
    );
  }
  protected doSubmit() {
    // TODO
  }
}



// WEBPACK FOOTER //
// ./src/containers/SignIn/SignInForm.tsx